export { PerfectMatchSwitch } from './PerfectMatchSwitch.component';
